import "./Projects.css";

/* MUTFAK */
import mutfak1 from "../images/projects/mutfak/mutfak1.jpeg";
import mutfak2 from "../images/projects/mutfak/mutfak2.jpeg";
import mutfak3 from "../images/projects/mutfak/mutfak3.jpeg";
import mutfak4 from "../images/projects/mutfak/m4.jpeg";
import mutfak5 from "../images/projects/mutfak/mutfak5.jpeg";
import mutfak6 from "../images/projects/mutfak/mutfak6.jpeg";
import mutfak7 from "../images/projects/mutfak/mutfak7.jpeg";
import mutfak8 from "../images/projects/mutfak/mutfak8.jpeg";
import mutfak9 from "../images/projects/mutfak/mutfak9.jpeg";
import mutfak10 from "../images/projects/mutfak/mutfak10.jpeg";
import mutfak11 from "../images/projects/mutfak/mutfak11.jpeg";


/* MEZAR */
import mezar1 from "../images/projects/mezar/mezar1.jpeg";
import mezar2 from "../images/projects/mezar/mezar2.jpeg";
import mezar3 from "../images/projects/mezar/mezar3.jpeg";
import mezar4 from "../images/projects/mezar/mezar4.jpeg";
import mezar5 from "../images/projects/mezar/mezar5.jpeg";
import mezar6 from "../images/projects/mezar/mezar6.jpeg";
import mezar7 from "../images/projects/mezar/mezar7.jpeg";
import mezar8 from "../images/projects/mezar/mezar8.jpeg";
import mezar9 from "../images/projects/mezar/mezar9.jpeg";
import mezar10 from "../images/projects/mezar/mezar10.jpeg";
import mezar11 from "../images/projects/mezar/mezar6.jpg";

/* Merdiven */

import merdiven1 from "../images/projects/merdiven/merdiven1.jpeg"
import merdiven2 from "../images/projects/merdiven/merdiven2.jpeg"
import merdiven3 from "../images/projects/merdiven/merdiven3.jpeg"
import merdiven4 from "../images/projects/merdiven/merdiven4.jpeg"
import merdiven5 from "../images/projects/merdiven/merdiven5.jpeg"
import merdiven6 from "../images/projects/merdiven/merdiven6.jpeg"
import merdiven7 from "../images/projects/merdiven/merdiven7.jpeg"
import merdiven8 from "../images/projects/merdiven/merdiven8.jpeg"
import merdiven9 from "../images/projects/merdiven/merdiven9.jpeg"
import merdiven10 from "../images/projects/merdiven/merdiven10.jpeg"
import merdiven11 from "../images/projects/merdiven/merdiven11.jpeg"

export default function Projects() {

  return (
    <section className="projects-page">

      <div className="projects-header">
        <h1>Projelerimiz</h1>
      </div>

      {/* MUTFAK */}

      <div className="category">

        <h2>Mutfak</h2>

        <div className="projects-grid">

          <img src={mutfak1} alt="" />
          <img src={mutfak2} alt="" />
          <img src={mutfak3} alt="" />
           <img src={mutfak4} alt="" />
          <img src={mutfak5} alt="" />
          <img src={mutfak6} alt="" />
          <img src={mutfak7} alt="" />
          <img src={mutfak8} alt="" />
          <img src={mutfak9} alt="" />
          <img src={mutfak10} alt="" />
          <img src={mutfak11} alt="" />

        </div>

      </div>

      {/* MEZAR */}

      <div className="category">

        <h2>Mezar</h2>

        <div className="projects-grid">

          <img src={mezar1} alt="" />
          <img src={mezar2} alt="" />
          <img src={mezar3} alt="" />
          <img src={mezar4} alt="" />
          <img src={mezar5} alt="" />
          <img src={mezar6} alt="" />
          <img src={mezar7} alt="" />
          <img src={mezar8} alt="" />
          <img src={mezar9} alt="" />
          <img src={mezar10} alt="" />
          <img src={mezar11} alt="" />

        </div>

      </div>

        <div className="category">

            <h2>Merdiven</h2>

            <div className="projects-grid">

        <img src={merdiven1} alt="" />
          <img src={merdiven2} alt="" />
          <img src={merdiven3} alt="" />
          <img src={merdiven4} alt="" />
          <img src={merdiven5} alt="" />
          <img src={merdiven6} alt="" />
          <img src={merdiven7} alt="" />
          <img src={merdiven8} alt="" />
          <img src={merdiven9} alt="" />
          <img src={merdiven10} alt="" />
          <img src={merdiven11} alt="" />

            </div>
        </div>
    </section>
  );
}